<div class="layout-wrapper" [ngClass]="containerClass()">

  <!-- Sidebar — hidden for Provider-only users -->
  @if (!isProviderUser) {
    <div
      class="layout-sidebar"
      (mouseenter)="onSidebarMouseEnter()"
      (mouseleave)="onSidebarMouseLeave()">
      <app-sidebar />
    </div>
  }

  <!-- Main area -->
  <div class="layout-main-container">
    @if (isOffline()) {
      <div class="conn-banner conn-banner--offline" role="alert">
        <i class="pi pi-wifi"></i>
        <span>No internet connection. Please check your network and try again.</span>
      </div>
    } @else if (isSlowNetwork()) {
      <div class="conn-banner conn-banner--slow" role="alert">
        <i class="pi pi-exclamation-triangle"></i>
        <span>Your internet connection is slow. Pages may take longer to load.</span>
      </div>
    }
    <app-topbar />
    <div class="layout-main">
      <router-outlet />
    </div>
    <footer class="layout-footer">
      &copy; {{ year }} Saisystems Health. All rights reserved.
    </footer>
  </div>

  <!-- Overlay mask (overlay & mobile) -->
  <div class="layout-mask" (click)="onMaskClick()"></div>

  <!-- App-wide idle / inactivity timeout popup -->
  <app-idle-timeout />

</div>
